import { apiClient } from '@/services/apiClient';

export type LandingPageInquiryResponse = {
    success: boolean;
};

export const landingPageInquiryService = {
    submitInquiry(email: string, message: string) {
        return apiClient.post<LandingPageInquiryResponse>('/landing-page-inquiries', { email, message });
    },
};
